import { UnitCurrentStatus, UnitsSource } from "api/units";

export interface UnitsFilters {
  states: string[];
  cities: string[];
  property_group_ids: number[];
  property_ids: number[];
  unit_ids: number[];
  current_statuses: UnitCurrentStatus[];
  owner_ids: number[];
  sources: UnitsSource[];
  needs_lockbox: boolean;
  no_lockbox: boolean;
}

export const EMPTY_UNITS_FILTERS: UnitsFilters = {
  states: [],
  cities: [],
  property_group_ids: [],
  property_ids: [],
  unit_ids: [],
  current_statuses: [],
  owner_ids: [],
  sources: [],
  needs_lockbox: false,
  no_lockbox: false
};

export const NO_LOCKBOX_FILTER_PARAM = "lockbox";
export const NO_LOCKBOX_FILTER_VALUE = "no_lockbox";

export const countActiveUnitsFilters = ({
  needs_lockbox,
  no_lockbox,
  ...listFilters
}: UnitsFilters) =>
  Object.values(listFilters).reduce(
    (total, values) => total + values.length,
    Number(needs_lockbox) + Number(no_lockbox)
  );
